import { FormsEntityType } from '@sharefiledev/dynamic-forms-pilet-sdk';
import {
	Capabilities,
	CapabilityRecord,
} from '@sharefiledev/sfplugin-capability-contracts';
import { RID } from '@sharefiledev/sfplugin-resource-id';
import { defaultDataProvider } from '../api';
import { shortRequestURISegment, shortResponseURISegment } from '../config/constants';

export const SolutionActiveTabParamName = 'activeTab';

export function getCapabilities(): CapabilityRecord {
	const informationRequestCapabilities: Capabilities = {
		async getNavigationDetails(requestedByResourceId) {
			const requestRID = getResourceRID(
				requestedByResourceId,
				FormsEntityType.informationRequest
			);
			const requestDetails = await defaultDataProvider.getInformationRequest(
				requestedByResourceId
			);
			const webAppPath = `${shortRequestURISegment}/${encodeURIComponent(
				requestRID.toString()
			)}`;
			return {
				name: requestDetails?.name,
				webAppPath,
			};
		},
	};

	const informationResponseCapabilities: Capabilities = {
		async getNavigationDetails(requestedByResourceId) {
			const responseRID = getResourceRID(
				requestedByResourceId,
				FormsEntityType.informationResponse
			);
			const requestRID = getResourceRID(
				requestedByResourceId,
				FormsEntityType.informationRequest
			);
			const searchParams = new URLSearchParams();
			searchParams.set(shortResponseURISegment, responseRID.entityId);
			const webAppPath = `/${shortRequestURISegment}/${encodeURIComponent(
				requestRID.toString()
			)}?${searchParams.toString()}`;
			return {
				name: '',
				webAppPath,
			};
		},
	};

	const getResourceRID = (resourceId: string, resourceType: FormsEntityType) => {
		const rid = RID.parse(resourceId);
		const entityRID = rid.findEntityType(resourceType);
		if (!entityRID) {
			throw new Error(`No ${resourceType} resource found for: ${resourceId}`);
		}
		return entityRID;
	};

	return {
		[FormsEntityType.informationRequest]: informationRequestCapabilities,
		[FormsEntityType.informationResponse]: informationResponseCapabilities,
	};
}
